module.exports = __webpack_public_path__ + "static/form-mobile-099e5b005fde3e4a2f6a186e6c8d2a33.png";